<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto d-flex gap-3 align-items-center">
          <h2 class="mb-0">
            {{ orderType === "inventory-sales" ? "Inventory Sales" : "Orders" }}
          </h2>
          <span class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
            <jni-spinner></jni-spinner>
          </span>

          <label class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              id="Canceled"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              value="Canceled"
              (click)="getOrderOnChange('Canceled')" />

            <span class="link">Canceled</span>
          </label>

          <label class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              id="Delivered"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              value="Delivered"
              (click)="getOrderOnChange('Delivered')" />

            <span class="link">Delivered</span>
          </label>

          <label class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              id="Invoiced"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              value="Invoiced"
              (click)="getOrderOnChange('Invoiced')" />

            <span class="link">Invoiced</span>
          </label>

          <label class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              id="Openorder"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              value="Openorder"
              (click)="getOrderOnChange('Open order')" />

            <span class="link">Open order</span>
          </label>

          <label class="ms-2 nav-link p-0 d-flex align-items-center">
            <p-radioButton
              id="All"
              class="me-2"
              name="radio"
              [(ngModel)]="selectedRadioButton"
              value="All"
              (click)="getOrderOnChange('All')" />

            <span class="link">All</span>
          </label>
        </span>
        <span class="d-flex gap-3 customizefilter-btn align-items-center">
          <div
            class="prospects-panel d-flex justify-content-between gap-3 align-items-center"
            *ngIf="!isAdditionalFilters">
            <button
              *ngIf="
                _sharedService.getOrderSearchValue() &&
                _sharedService.getOrderSearchValue()?.length
              "
              class="btn btn-warning w-30 ms-4"
              type="submit"
              (click)="onClear()">
              Clear
            </button>

            <!-- <button
              *ngIf="
                _sharedService.getOrderSearchValue() &&
                _sharedService.getOrderSearchValue()?.length
              "
              class="btn btn-warning w-30 ms-4"
              type="submit"
              (click)="onClear()"
              style="height: 100%">
              Clear
            </button> -->
            <div *ngIf="searchPlaceholder !== 'Search'" class="ms-2">
              <span class="text-primary font-weight-bold">{{
                filterSaleordersListing.length
              }}</span>
              <span> Results for </span>
              <span class="text-primary">
                <!-- <span>"</span> -->
                <span>{{ _sharedService.getOrderSearchValue() }}</span>
                <!-- <span>"</span> -->
              </span>
            </div>
          </div>

          <p-button
            label="Export excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            class="link"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />

          <p-button
            label="Add New Order"
            icon="pi pi-plus"
            (click)="onOrdersRedirection()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-lg-12">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="50"
          scrollDirection="both"
          [scrollable]="true"
          scrollHeight="calc(100vh - 261px)"
          [size]="'small'"
          responsiveLayout="scroll"
          [value]="filterSaleordersListing"
          [(selection)]="selectedorderListing"
          styleClass="p-datatable-customers ordersListing search-more"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          styleClass="table-listing"
          [filterDelay]="0"
          (onFilter)="onFilter($event, dt)"
          (onPage)="setMyPagination(dt)"
          selectionMode="multiple"
          sortMode="multiple">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th
                style="width: 3rem"
                class="number"
                pSortableColumn="salesOrderIdD365">
                Order # <p-sortIcon field="salesOrderIdD365"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="orderPercentCompleteD365">
                PCT
                <p-sortIcon field="orderPercentCompleteD365"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="salesOrderStatusD365">
                Status
                <p-sortIcon field="salesOrderStatusD365"></p-sortIcon>
              </th>
              <th class="name" pSortableColumn="organizationNameD365">
                Client Name
                <p-sortIcon field="organizationNameD365"></p-sortIcon>
              </th>
              <th
                *ngIf="userRole === enumUserRole.Admin"
                class="name"
                pSortableColumn="jniSalesInventoryD365">
                Inventory Sales
              </th>
              <th
                class="jname"
                pSortableColumn="jobNameD365"
                [ngClass]="{ trimmedby30char: descriptionCharacterCond }">
                Job Name
                <p-sortIcon field="jobNameD365"></p-sortIcon>
              </th>
              <th class="buyer" pSortableColumn="buyerD365">
                Buyer
                <p-sortIcon field="buyerD365"></p-sortIcon>
              </th>
              <th class="inhanddate" pSortableColumn="inHandsDateD365">
                In Hands
                <p-sortIcon field="inHandsDateD365"></p-sortIcon>
              </th>
              <th class="date-time" pSortableColumn="createdDate">
                Created
                <p-sortIcon field="createdDate"></p-sortIcon>
              </th>
              <th class="subtotal" pSortableColumn="orderSubTotal">
                Subtotal
                <p-sortIcon field="orderSubTotal"></p-sortIcon>
              </th>
              <th class="prepay">PrePay</th>
              <th class="commission">Comm</th>
              <th class="gp">GP $</th>
              <th class="gp">Gp%</th>
              <th class="currency">Curr</th>

              <th
                class="cust-po"
                pSortableColumn="customerPONumberD365"
                [ngClass]="{ trimmedby15char: custPoCharacterCount }">
                Cust PO #
                <p-sortIcon field="customerPONumberD365"></p-sortIcon>
              </th>
              <th class="bconsultant">BC</th>
              <th class="bconsultant">Prime Support</th>
              <th class="status">Paid Status</th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="salesOrderIdD365"
                    id="salesOrderIdD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrderIdD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="salesOrderStatusD365"
                    id="salesOrderStatusD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrderStatusD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="organizationNameD365"
                    id="organizationNameD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'organizationNameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th *ngIf="userRole === enumUserRole.Admin">
                <!-- <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="jniSalesInventoryD365"
              id="jniSalesInventoryD365"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value[0]?.toLowerCase() === 'y',
                  'jniSalesInventoryD365',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component"
            />
          </div> -->
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="jobNameD365"
                    id="jobNameD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'jobNameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="buyerD365"
                    id="buyerD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'buyerD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <jni-date-filter
                  [dataList]="saleordersListing"
                  [filteredDataList]="filterSaleordersListing"
                  [columnName]="inHandDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th>
                <jni-date-filter
                  [dataList]="saleordersListing"
                  [filteredDataList]="filterSaleordersListing"
                  [columnName]="createdDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th>
                <!-- Subtotal -->
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="orderSubTotal"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'orderSubTotal',
                        'startsWith'
                      )
                    "
                    [showMenu]="false"></p-columnFilter>
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="foreignCurrencyD365"
                    id="foreignCurrencyD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'foreignCurrencyD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="customerPONumberD365"
                    id="customerPONumberD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'customerPONumberD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="brandingConsultant"
                    id="brandingConsultant"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'brandingConsultant',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="accountsCoordinatorNameD365"
                    id="accountsCoordinatorNameD365"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'accountsCoordinatorNameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-saleordersListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="saleordersListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  class=""
                  [value]="saleordersListing"
                  [pSelectableRow]="saleordersListing"></p-tableCheckbox>
              </td>
              <td class="number">
                <a
                  class="link"
                  (click)="
                    redirectToSummary(saleordersListing.salesOrderIdD365)
                  ">
                  {{ saleordersListing.salesOrderIdD365 }}</a
                >
              </td>
              <td class="number text-center">
                <a
                  *ngIf="
                    saleordersListing?.invoiceProposalExists !== '' &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() ===
                      'yes'
                  "
                  class="link i-perview-color"
                  (click)="
                    getProjectInvoiceProposalsBySalesOrderId(
                      saleordersListing.salesOrderIdD365
                    )
                  ">
                  {{
                    saleordersListing.orderPercentCompleteD365 | number: "1.2-2"
                  }}</a
                >

                <a
                  *ngIf="
                    saleordersListing?.orderPercentCompleteD365 > 0 &&
                    saleordersListing?.orderPercentCompleteD365 < 93.99 &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() !==
                      'yes'
                  "
                  class="link"
                  (click)="
                    redirectToIRSummary(
                      saleordersListing?.salesOrderIdD365,
                      saleordersListing?.projIdD365
                    )
                  ">
                  {{
                    saleordersListing.orderPercentCompleteD365 | number: "1.2-2"
                  }}</a
                >

                <a
                  *ngIf="
                    saleordersListing?.orderPercentCompleteD365 >= 94 &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() !==
                      'yes'
                  "
                  class="link"
                  style="background-color: yellow; padding: 5px; color: black"
                  (click)="
                    redirectToIRSummary(
                      saleordersListing?.salesOrderIdD365,
                      saleordersListing?.projIdD365
                    )
                  ">
                  {{
                    saleordersListing.orderPercentCompleteD365 | number: "1.2-2"
                  }}</a
                >
              </td>
              <td class="status">
                <a
                  class="link"
                  (click)="onStatusClick(saleordersListing.salesOrderIdD365)"
                  *ngIf="
                    saleordersListing?.salesOrderStatusD365?.toLowerCase() ===
                      'invoiced' &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() !==
                      'yes'
                  ">
                  {{ saleordersListing.salesOrderStatusD365 }}
                </a>
                <span
                  *ngIf="
                    !(
                      saleordersListing?.salesOrderStatusD365?.toLowerCase() ===
                      'invoiced'
                    ) &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() !==
                      'yes'
                  "
                  >{{ saleordersListing.salesOrderStatusD365 }}</span
                >
                <span
                  class="i-perview-color"
                  *ngIf="
                    saleordersListing?.invoiceProposalExists !== '' &&
                    saleordersListing?.invoiceProposalExists?.toLowerCase() ===
                      'yes'
                  ">
                  I-Preview
                </span>
              </td>
              <td class="name">
                <a
                  class="link"
                  (click)="
                    redirectToClientSummary(
                      saleordersListing.customerAccountNumber
                    )
                  ">
                  {{ saleordersListing.organizationNameD365 }}</a
                >
              </td>
              <td
                *ngIf="userRole === enumUserRole.Admin"
                class="name"
                style="padding-left: 2.5rem; border-left: 1px solid #dcdcdc">
                {{
                  saleordersListing.jniSalesInventoryD365 | jniBooleanToString
                }}
              </td>
              <td
                class="jname"
                [ngClass]="{
                  'trimmeddescription trimmedby30char':
                    descriptionCharacterCond,
                }">
                {{ descriptionCharacterCount(saleordersListing.jobNameD365) }}
                {{ saleordersListing.jobNameD365 }}
              </td>
              <td class="buyer">{{ saleordersListing.buyerD365 }}</td>
              <td class="inhandate">
                {{ saleordersListing.inHandsDateD365 | date: "MM-dd-yyyy" }}
              </td>
              <td class="date-time">
                <span *ngIf="saleordersListing?.createdDate | hidedynamicsdate">
                  {{ saleordersListing.createdDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td class="subtotal">
                {{
                  saleordersListing.orderSubTotal
                    | currency
                      : saleordersListing.foreignCurrencyD365
                      : "symbol"
                      : "0.2-2"
                }}
              </td>
              <td class="prepay">
                {{
                  saleordersListing.clientDepositD365
                    | currency
                      : saleordersListing.foreignCurrencyD365
                      : "symbol"
                      : "0.2-2"
                }}
              </td>
              <td class="commission">
                {{ saleordersListing.commissionD365 | currency }}
              </td>
              <td class="gp">
                {{ saleordersListing.grossProfitD365 | currency }}
              </td>
              <td class="gp">
                <span
                  *ngIf="
                    saleordersListing.grossProfitPercentageD365 !== 'NaN' &&
                    getInfinity(saleordersListing.grossProfitPercentageD365)
                  ">
                  {{
                    saleordersListing.grossProfitPercentageD365
                      | number: "1.2-2"
                  }}
                </span>
                <span
                  *ngIf="
                    saleordersListing.grossProfitPercentageD365 === 'NaN' &&
                    !getInfinity(saleordersListing.grossProfitPercentageD365)
                  ">
                  {{ 0 | number: "1.2-2" }}
                </span>
              </td>
              <td class="currency">
                {{ saleordersListing.foreignCurrencyD365 }}
              </td>

              <td
                class="cust-po"
                [ngClass]="{
                  'trimmeddescription trimmedby15char': custPoCharacterCount,
                }">
                {{
                  custPoCharacterCountMethod(
                    saleordersListing.customerPONumberD365
                  )
                }}
                {{ saleordersListing.customerPONumberD365 }}
              </td>
              <td class="bconsultant">
                {{ saleordersListing.brandingConsultant }}
              </td>
              <td class="bconsultant">
                {{ saleordersListing.accountsCoordinatorNameD365 }}
              </td>
              <td class="name">
                <span
                  *ngIf="
                    saleordersListing?.prepayD365 === 'Paid' ||
                    saleordersListing?.prepayD365 === 'Unpaid'
                  ">
                  {{ saleordersListing.prepayD365 }}
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No sale orders found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer" *ngIf="false">
            <tr
              *ngIf="
                listAfterGridFilter.length > currentPagination && lastPageStatus
              ">
              <td colspan="20">More records exist</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="orders py-3 pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>
      {{ orderType === "inventory-sales" ? "Inventory Sales" : "Orders" }}
    </h1>
    <div
      class="prospects-panel d-flex justify-content-between ms-2 me-auto"
      *ngIf="!isAdditionalFilters">
      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="Canceled"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getOrderOnChange($event)" />

        <span class="link">Canceled</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="Delivered"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getOrderOnChange($event)" />

        <span class="link">Delivered</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="Invoiced"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getOrderOnChange($event)" />

        <span class="link">Invoiced</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="Openorder"
          type="radio"
          class="me-2"
          name="radio"
          (click)="getOrderOnChange($event)" />

        <span class="link">Open order</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input
          id="All"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="true"
          (click)="getOrderOnChange($event)" />

        <span class="link">All</span>
      </label>
      <button
        *ngIf="
          _sharedService.getOrderSearchValue() &&
          _sharedService.getOrderSearchValue()?.length
        "
        class="btn btn-warning w-30 ms-4"
        type="submit"
        (click)="onClear()"
        style="height: 100%">
        Clear
      </button>
      <div *ngIf="searchPlaceholder !== 'Search'" class="ms-2">
        <span class="text-primary font-weight-bold">{{
          filterSaleordersListing.length
        }}</span>
        <span> Results for </span>
        <span class="text-primary">
          
          <span>{{ _sharedService.getOrderSearchValue() }}</span>
         
        </span>
      </div>
    </div>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <jni-spinner></jni-spinner>
    </div>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="pi pi-cloud-upload icon-blue mx-1"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Add me-2"></i>
        <a class="link" (click)="onOrdersRedirection()">Add New Order</a>
      </div>
    </div>
  </header>
  
</div> -->

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>
<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeClientModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="customerId"
      (closeEvent)="closeClientModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-invoice-pdf-dialogue
  [displayModal]="invoicePdfDialogue"
  *ngIf="invoiceList?.length"
  (closeDialogEvent)="closeUrlDialog()"
  [invoiceList]="invoiceList"></jni-invoice-pdf-dialogue>

<jni-invoice-preview-list-dailog
  [displayModal]="displayProjectInvoiceProposal"
  [projectInvoicesProposalList]="projectInvoicesProposalList"
  (closeDialogEvent)="closeProjectInvoiceProposalEvent()"
  [showSmallLoader]="popupSmallLoader">
</jni-invoice-preview-list-dailog>
